import React from 'react';
import H1 from "../../../UI/H1";
import SectionWrapper from "../../../UI/SectionWrapper";
import { makeStyles } from "@material-ui/core/styles";
import StyledButton from "../../../UI/StyledButton";
import { Grid } from "@material-ui/core";
import ProjectCard from "../../../UI/ActualProjectsCard";
import {themes} from "../../../../theme/themeContext/themes";
import {useTheme} from "../../../../theme/themeContext";
import UnderLine from "../../../UI/LineUnderTitle";

const useStyles = makeStyles((theme) => ({
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

const ActualProjectsBlock = () => {
    const {theme} = useTheme();
    const classes = useStyles(themes[theme]);

    return (
        <SectionWrapper id="main-actual-projects">
            <H1 text="Projekty"/>
            <UnderLine/>
            <ProjectCard projectLimit={4}/>
            <Grid container spacing={3} className={classes.buttonContainer}>
                <Grid item xs={12} sm={6} md={4}>
                    <StyledButton text="Zobacz więcej" href="/aktualnosci" width="100%" to="/projekty"/>
                </Grid>
            </Grid>
        </SectionWrapper>
    );
};

export default ActualProjectsBlock;